import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cxsplice',
})
export class CxSplicePipe implements PipeTransform {
  transform(val: string, start: number = 0, end: number = 50): string {
    val = String(val);
    if (val.length > end) {
      return val.slice(start, end) + ' ...';
    }

    return val;
  }
}
